/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOpen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22.4 10.1 20.2 9l2.2-1.1c.4-.2.6-.5.6-.9s-.2-.7-.6-.9l-6-3c-.3-.1-.6-.1-.9 0L12 4.9 8.4 3.1c-.2-.1-.6-.1-.8 0l-6 3c-.4.2-.6.5-.6.9s.2.7.6.9L3.8 9l-2.2 1.1c-.4.2-.6.5-.6.9s.2.7.6.9L5 13.6V17c0 .4.2.7.6.9l6 3c.1.1.2.1.4.1s.3 0 .4-.1l6-3c.3-.2.6-.5.6-.9v-3.4l3.4-1.7c.3-.2.6-.5.6-.9s-.2-.7-.6-.9zM8 5.1l1.8.9L6 7.9 4.2 7zM4.2 11l1.8-.9L9.8 12l-1.8.9zm6.8 7.4-4-2v-1.8l.6.3c.3.1.6.1.9 0l2.6-1.3v4.8zm1-7.5L8.2 9 12 7.1 15.8 9zm5 5.5-4 2v-4.8l2.6 1.3c.3.1.6.1.9 0l.6-.3v1.8zm-1-3.5-1.8-.9 3.8-1.9 1.8.9zm2-5L14.2 6l1.8-.9L19.8 7z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgOpen as Open };
